import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player/lazy';
import config from 'utils/config';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Button from 'components/Button';
import Panel from 'components/Panel';
import Landmark from 'components/Landmark';
import { HelixEmailLink, SettingsLink } from 'screens/UserSkills';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OPTION_1_STEP_KEYS = ['trial_welcome_option_1_step_1', 'trial_welcome_option_1_step_3', 'trial_welcome_option_1_step_4', 'trial_welcome_option_1_step_5'];
var SKILL_KEYS = ['trial_welcome_skill_accountability', 'trial_welcome_skill_coachability', 'trial_welcome_skill_growth_mindset', 'trial_welcome_skill_communication', 'trial_welcome_skill_active_listening', 'trial_welcome_skill_coaching', 'trial_welcome_skill_strategic_vision', 'trial_welcome_skill_change_management', 'trial_welcome_skill_results_focused'];
function TrialInfo() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var trialWelcomeVideoUrl = config.trialWelcomeVideoUrl;
  var hasVideo = Boolean(trialWelcomeVideoUrl);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasVideo && /*#__PURE__*/_jsx(Panel, {
      flush: true,
      align: "center",
      children: /*#__PURE__*/_jsx("div", {
        style: {
          width: '100%',
          height: '100%',
          position: 'relative',
          paddingTop: '56.25%'
        },
        children: /*#__PURE__*/_jsx(ReactPlayer, {
          fallback: /*#__PURE__*/_jsx(Landmark, {
            icon: "spinner",
            height: 250,
            children: t('loading_video')
          }),
          style: {
            position: 'absolute',
            top: 0,
            left: 0
          },
          playing: false,
          url: trialWelcomeVideoUrl,
          controls: true,
          width: "100%",
          height: "100%",
          config: {
            youtube: {
              playerVars: {
                start: 0
              }
            }
          }
        })
      })
    }), /*#__PURE__*/_jsxs(Stack, {
      spacing: "l",
      mt: hasVideo ? 'l' : undefined,
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h3",
        size: "medium",
        mb: "m",
        children: t('trial_welcome_get_started_title')
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_intro')
        }), /*#__PURE__*/_jsx(Heading, {
          as: "h4",
          size: "small",
          mb: "0",
          mt: "s",
          children: t('trial_welcome_option_1_title')
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          as: "ordered-list",
          ml: "l",
          style: {
            listStyleType: 'decimal',
            listStylePosition: 'outside',
            paddingInlineStart: '1.25rem'
          },
          children: [OPTION_1_STEP_KEYS.slice(0, 1).map(function (stepKey) {
            return /*#__PURE__*/_jsx(Text, {
              children: t(stepKey)
            }, stepKey);
          }), /*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsx(Trans, {
              i18nKey: "trial_welcome_option_1_step_2",
              components: [/*#__PURE__*/_jsx(HelixEmailLink, {}, "helix-email-link")]
            })
          }), OPTION_1_STEP_KEYS.slice(1).map(function (stepKey) {
            return /*#__PURE__*/_jsx(Text, {
              children: t(stepKey)
            }, stepKey);
          })]
        }), /*#__PURE__*/_jsx(Heading, {
          as: "h4",
          size: "small",
          mb: "0",
          mt: "s",
          children: t('trial_welcome_option_2_title')
        }), /*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_option_2_text_1')
        }), /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(Trans, {
            i18nKey: "trial_welcome_option_2_text_2",
            components: [/*#__PURE__*/_jsx(SettingsLink, {}, "settings-link")]
          })
        }), /*#__PURE__*/_jsx(Panel, {
          align: "center",
          flush: true,
          children: /*#__PURE__*/_jsx(Button, {
            as: Link,
            to: "/settings",
            icon: "calendar",
            variant: "primary",
            children: t('actions_go_to_settings')
          })
        })]
      }), /*#__PURE__*/_jsx(Heading, {
        as: "h3",
        size: "medium",
        mb: "m",
        children: t('trial_welcome_meeting_title')
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_meeting_text_1')
        }), /*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_meeting_text_2')
        }), /*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_meeting_text_3')
        })]
      }), /*#__PURE__*/_jsx(Heading, {
        as: "h3",
        size: "medium",
        mb: "m",
        children: t('trial_welcome_skills_title')
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_skills_intro')
        }), /*#__PURE__*/_jsx(Stack, {
          spacing: "xs",
          as: "list",
          ml: "l",
          children: SKILL_KEYS.map(function (skillKey) {
            return /*#__PURE__*/_jsx(Text, {
              bold: true,
              children: t(skillKey)
            }, skillKey);
          })
        }), /*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_skills_outro')
        })]
      }), /*#__PURE__*/_jsx(Heading, {
        as: "h3",
        size: "medium",
        mb: "m",
        children: t('trial_welcome_opt_out_title')
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_opt_out_intro')
        }), /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(Trans, {
            i18nKey: "trial_welcome_opt_out_remove_email",
            components: [/*#__PURE__*/_jsx(HelixEmailLink, {}, "helix-email-link")]
          })
        }), /*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_opt_out_started')
        }), /*#__PURE__*/_jsx(Text, {
          children: t('trial_welcome_opt_out_assurance')
        })]
      })]
    })]
  });
}
export default TrialInfo;